module.exports = __webpack_public_path__ + "img/swiper-img2-thumb.88b2bb11.png";